import { z } from 'zod'

export function normalizeTenantCode(value: string) {
  return value.trim().toUpperCase()
}

export const tenantCodeSchema = z
  .string({ error: '请输入英文简称' })
  .trim()
  .min(1, '请输入英文简称')
  .transform(normalizeTenantCode)
  .pipe(z.string().regex(/^[A-Z]{2,4}$/, '英文简称须为 2 到 4 位大写字母'))
